import { render, staticRenderFns } from "./c_upload_video.vue?vue&type=template&id=23d35e9c&scoped=true"
import script from "./c_upload_video.vue?vue&type=script&lang=js"
export * from "./c_upload_video.vue?vue&type=script&lang=js"
import style0 from "./c_upload_video.vue?vue&type=style&index=0&id=23d35e9c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d35e9c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/mac/Documents/project/code/shop/zhongyijia-admin-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23d35e9c')) {
      api.createRecord('23d35e9c', component.options)
    } else {
      api.reload('23d35e9c', component.options)
    }
    module.hot.accept("./c_upload_video.vue?vue&type=template&id=23d35e9c&scoped=true", function () {
      api.rerender('23d35e9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobileConfigRight/c_upload_video.vue"
export default component.exports